import { render, staticRenderFns } from "./ChatModel.vue?vue&type=template&id=5b83e940&scoped=true"
import script from "./ChatModel.vue?vue&type=script&lang=js"
export * from "./ChatModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83e940",
  null
  
)

export default component.exports